import { render, staticRenderFns } from "./BrandTutorialVideos.vue?vue&type=template&id=7238dc64&scoped=true&"
import script from "./BrandTutorialVideos.vue?vue&type=script&lang=ts&"
export * from "./BrandTutorialVideos.vue?vue&type=script&lang=ts&"
import style0 from "./BrandTutorialVideos.vue?vue&type=style&index=0&id=7238dc64&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7238dc64",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1771009219/src/capas-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7238dc64')) {
      api.createRecord('7238dc64', component.options)
    } else {
      api.reload('7238dc64', component.options)
    }
    module.hot.accept("./BrandTutorialVideos.vue?vue&type=template&id=7238dc64&scoped=true&", function () {
      api.rerender('7238dc64', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/SAdmin/BrandTutorialVideos.vue"
export default component.exports